export * from './banking-deposit.dto';
export * from './banking-deposit-patch.dto';
export * from './banking-deposit-search.dto';
export * from './banking-deposit-stats.dto';